import { Section, BillingFrequency, ServiceDuration } from "./types";
import { getBillingFrequencyTKey, getServiceDurationTKey } from "./utils";

export const SECTIONS: Section[] = [
  { id: 1, name: "settings.product.sections.softwareServices" },
  { id: 2, name: "settings.product.sections.professionalServices" }
];

export const BILLING_FREQUENCY_OPTIONS = [
  {
    id: BillingFrequency.MONTHLY,
    tKey: getBillingFrequencyTKey(BillingFrequency.MONTHLY)
  },
  {
    id: BillingFrequency.QUARTERLY,
    tKey: getBillingFrequencyTKey(BillingFrequency.QUARTERLY)
  },
  {
    id: BillingFrequency.ANNUALLY,
    tKey: getBillingFrequencyTKey(BillingFrequency.ANNUALLY)
  },
  {
    id: BillingFrequency.ONCE,
    tKey: getBillingFrequencyTKey(BillingFrequency.ONCE)
  },
  {
    id: BillingFrequency.CUSTOM,
    tKey: getBillingFrequencyTKey(BillingFrequency.CUSTOM),
    subtitleTKey: "settings.product.billingFrequency.customSubtitle"
  }
];

export const SERVICE_DURATION_OPTIONS = [
  {
    id: ServiceDuration.ONE_MONTH,
    tKey: getServiceDurationTKey(ServiceDuration.ONE_MONTH)
  },
  {
    id: ServiceDuration.ONE_YEAR,
    tKey: getServiceDurationTKey(ServiceDuration.ONE_YEAR)
  },
  {
    id: ServiceDuration.TWO_YEARS,
    tKey: getServiceDurationTKey(ServiceDuration.TWO_YEARS)
  },
  {
    id: ServiceDuration.THREE_YEARS,
    tKey: getServiceDurationTKey(ServiceDuration.THREE_YEARS)
  },
  {
    id: ServiceDuration.CUSTOM,
    tKey: getServiceDurationTKey(ServiceDuration.CUSTOM)
  }
];

export const PRODUCTS_SETTINGS_PATH = "/settings/productsLicenses";
